import type { FunctionComponent } from 'react';
import { GovernmentDataV2DisclaimerContent } from './subcomponents/GovernmentDataV2DisclaimerContent';
import { DialogModal } from '../../../app-kit/components/DialogModal/DialogModal';

interface GovernmentDataDisclaimerProps {
  opened: boolean;
  onClose: () => void;
}

export const GovernmentDataDisclaimer: FunctionComponent<GovernmentDataDisclaimerProps> = ({
  opened,
  onClose,
}) => {
  return (
    <DialogModal
      opened={opened}
      onClose={onClose}
      title="Government data"
      primaryButtonText="Got it"
      primaryButtonOnClick={onClose}
      gap="0"
    >
      <GovernmentDataV2DisclaimerContent />
    </DialogModal>
  );
};
